<template>
	<BaseCard alt class="relative flex items-center gap-4 p-5" v-if="show">
		<InfoIcon class="text-label-secondary h-6 w-6 shrink-0" />
		<div class="flex-1">
			<div class="text-label-primary text-sm font-medium uppercase">
				{{ props.title }}
			</div>
			<div class="text-label-secondary mt-1 text-sm">{{ props.desc }}</div>
		</div>
		<CloseSmIcon
			class="text-label-tertiary absolute top-3 right-3 h-5 w-5 after:absolute after:-inset-3"
			v-hover="{ active: 'scale-90', impact: 'soft' }"
			@click="close()"
		/>
	</BaseCard>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import BaseCard from './BaseCard.vue'
import InfoIcon from '@/assets/icons/info.svg'
import CloseSmIcon from '@/assets/icons/close-sm.svg'

const props = defineProps<{
	id: string
	title: string
	desc: string
}>()

const show = ref(!localStorage.getItem(`alert-${props.id}`))

const close = () => {
	show.value = false
	localStorage.setItem(`alert-${props.id}`, '0')
}
</script>
